var map = {
	"./BAT-logo.png": 536,
	"./BUSD-logo.png": 537,
	"./COMP-logo.png": 538,
	"./CRV-icon.png": 1386,
	"./CRV-logo.jpg": 1387,
	"./CRV-logo.png": 539,
	"./DAI-logo.png": 540,
	"./ERPH0DMWsAEWBjy.jpg": 1388,
	"./ETH-icon.png": 1389,
	"./ETH-logo.png": 541,
	"./FTM-logo.png": 542,
	"./IEARN-icon.png": 1390,
	"./KNC-logo.png": 543,
	"./LEND-logo.png": 544,
	"./LINK-logo.png": 545,
	"./MANA-logo.png": 546,
	"./MKR-logo.png": 547,
	"./REP-logo.png": 548,
	"./SAI-logo.png": 549,
	"./SNX-logo.png": 550,
	"./SUSD-logo.png": 551,
	"./TUSD-logo.png": 326,
	"./USDC-icon.png": 1391,
	"./USDC-logo.png": 552,
	"./USDT-icon.png": 1392,
	"./USDT-logo.png": 553,
	"./WETH-logo.png": 554,
	"./YFI-logo.png": 184,
	"./ZRX-logo.png": 555,
	"./aLINK-logo.png": 556,
	"./aave.png": 1393,
	"./aave.svg": 1394,
	"./alchemy.png": 1395,
	"./bzx.png": 1396,
	"./cUSDC-logo.png": 557,
	"./cUSDT-logo.png": 558,
	"./close_banner_icon.svg": 1397,
	"./coinbaseWalletIcon.svg": 335,
	"./compound.png": 1398,
	"./connect-wallet-slide-1.svg": 568,
	"./connect-wallet-slide-2.svg": 569,
	"./connect-wallet-slide-3.svg": 570,
	"./connect-wallet-slide-4.svg": 571,
	"./connect-wallet-slide-5.svg": 572,
	"./countries/de.svg": 585,
	"./countries/en.svg": 586,
	"./countries/es.svg": 587,
	"./countries/fr.svg": 588,
	"./countries/it.svg": 589,
	"./countries/ja.svg": 590,
	"./countries/nl.svg": 591,
	"./countries/pl.svg": 592,
	"./countries/pt.svg": 593,
	"./countries/ru.svg": 594,
	"./countries/zh.svg": 595,
	"./crvBTC-logo.png": 559,
	"./crvBUSD-logo.png": 560,
	"./curvefi.jpg": 1399,
	"./ddex.jpg": 1400,
	"./ddex.png": 1401,
	"./defipulse.png": 1402,
	"./defisnap.svg": 1403,
	"./defizap.png": 1404,
	"./discord.svg": 1405,
	"./dydx.jpg": 1406,
	"./dydx.svg": 1407,
	"./ethereum.png": 1408,
	"./etherscan.png": 1409,
	"./fonts/WorkSans-VariableFont_wght.ttf": 1410,
	"./fortmaticIcon.png": 331,
	"./github.svg": 1411,
	"./iDAI-logo.png": 561,
	"./icn-aethereum.svg": 334,
	"./icn-ledger.svg": 332,
	"./icn-metamask.svg": 327,
	"./kybernetwork.png": 1412,
	"./ledger.png": 1413,
	"./lendf.png": 1414,
	"./lendf.svg": 1415,
	"./medium.svg": 1416,
	"./metamask.png": 1417,
	"./metamask.svg": 1418,
	"./oCurve-logo.svg": 1419,
	"./oneinch.svg": 1420,
	"./portisIcon.png": 330,
	"./squarelink.png": 333,
	"./synthetix.png": 1421,
	"./telegram.svg": 1422,
	"./theme/beta-linear-line-dark.svg": 596,
	"./theme/connect-linear-lg-dark.svg": 576,
	"./theme/connect-linear-lg-light.svg": 577,
	"./theme/connect-linear-lg-waifu.svg": 578,
	"./theme/connect-linear-middle-dark.svg": 573,
	"./theme/connect-linear-middle-light.svg": 574,
	"./theme/connect-linear-middle-waifu.svg": 575,
	"./theme/footer-linear-dark.svg": 597,
	"./theme/footer-linear-light.svg": 598,
	"./theme/footer-linear-waifu.svg": 599,
	"./theme/info-banner-dark.svg": 600,
	"./theme/info-banner-light.svg": 601,
	"./theme/info-banner-waifu.svg": 602,
	"./theme/menu-apr-icon-hover.svg": 1423,
	"./theme/menu-apr-icon.svg": 1424,
	"./theme/menu-cover-icon-hover.svg": 603,
	"./theme/menu-cover-icon.svg": 604,
	"./theme/menu-earn-icon-hover.svg": 605,
	"./theme/menu-earn-icon.svg": 606,
	"./theme/menu-stats-icon-hover.svg": 336,
	"./theme/menu-stats-icon.svg": 337,
	"./theme/menu-vaults-icon-hover.svg": 607,
	"./theme/menu-vaults-icon.svg": 608,
	"./theme/menu-zap-icon-hover.svg": 609,
	"./theme/menu-zap-icon.svg": 610,
	"./theme/waifu_bg.png": 371,
	"./torus.jpg": 584,
	"./torus.svg": 567,
	"./trezor.png": 583,
	"./trezor.svg": 566,
	"./truffle.png": 1425,
	"./trustWallet.png": 329,
	"./twitter.svg": 1426,
	"./uniswap.png": 1427,
	"./uniswap.svg": 1428,
	"./wBTC-icon.png": 1429,
	"./wBTC-logo.png": 562,
	"./walletConnectIcon.svg": 328,
	"./yCRV-logo.jpg": 1430,
	"./yCRV-logo.png": 563,
	"./ycUSDC-logo.png": 564,
	"./ycUSDT-logo.png": 565
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1385;